// extracted by mini-css-extract-plugin
module.exports = {"Tech":"Tech_Tech__9HLed","techCtn":"Tech_techCtn__2Tzty"};